var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73799 1.57417C7.8987 1.47528 8.10139 1.47528 8.26209 1.57417L14.7621 5.57417C14.9526 5.69141 15.0421 5.92093 14.9811 6.13617C14.9202 6.35141 14.7237 6.5 14.5 6.5H1.50004C1.27634 6.5 1.07987 6.35141 1.01894 6.13617C0.95802 5.92093 1.04748 5.69141 1.23799 5.57417L7.73799 1.57417ZM3.26656 5.5H12.7335L8.00004 2.58709L3.26656 5.5Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 5.5C3.77614 5.5 4 5.72386 4 6V11C4 11.2761 3.77614 11.5 3.5 11.5C3.22386 11.5 3 11.2761 3 11V6C3 5.72386 3.22386 5.5 3.5 5.5Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 5.5C6.77614 5.5 7 5.72386 7 6V11C7 11.2761 6.77614 11.5 6.5 11.5C6.22386 11.5 6 11.2761 6 11V6C6 5.72386 6.22386 5.5 6.5 5.5Z",
    fill: "#202020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 5.5C9.77614 5.5 10 5.72386 10 6V11C10 11.2761 9.77614 11.5 9.5 11.5C9.22386 11.5 9 11.2761 9 11V6C9 5.72386 9.22386 5.5 9.5 5.5Z",
    fill: "#202020"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 5.5C12.7761 5.5 13 5.72386 13 6V11C13 11.2761 12.7761 11.5 12.5 11.5C12.2239 11.5 12 11.2761 12 11V6C12 5.72386 12.2239 5.5 12.5 5.5Z",
    fill: "#202020"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 11C1.5 10.7239 1.72386 10.5 2 10.5H14C14.2761 10.5 14.5 10.7239 14.5 11C14.5 11.2761 14.2761 11.5 14 11.5H2C1.72386 11.5 1.5 11.2761 1.5 11Z",
    fill: "#202020"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 13C0.5 12.7239 0.723858 12.5 1 12.5H15C15.2761 12.5 15.5 12.7239 15.5 13C15.5 13.2761 15.2761 13.5 15 13.5H1C0.723858 13.5 0.5 13.2761 0.5 13Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.0159cb17054f53aa9ae11ceca32cf8b3.svg";
export { ForwardRef as ReactComponent };